import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Table, Button, Tooltip, Divider, Popconfirm } from 'antd'
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import 'jspdf-autotable'
import './styles.css'

const { Column } = Table

const InventoryToolsTable = ({ data, onRemoveTool, onEditTool, onShowReservations, loading }) => {
    const didTapShowReservations = record => {
        onShowReservations(record)
    }

    const didTapEditInventory = record => {
        onEditTool(record)
    }

    const didTapRemoveInventory = record => {
        onRemoveTool(record)
    }

    return (
        <Table className="inventyTableCont" dataSource={data} rowKey="id" size="small" pagination={true}
               scroll={{ x: 800 }}>
            <Column title="Nombre" dataIndex="name" key="name" align="center" width="70%"/>
            <Column title="Acción" dataIndex="id" key="id" align="center" width="30%"
                    render={(text, record) => {
                        return (
                            <div>
                                <Tooltip title="Ver reservas">
                                    <Button loading={loading} onClick={() => didTapShowReservations(record)}
                                            icon={<EyeOutlined style={{ color: 'green' }}/>}/>
                                </Tooltip>
                                <Divider type="vertical"/>
                                <Tooltip title="Editar herramienta">
                                    <Button loading={loading} onClick={() => didTapEditInventory(record)}
                                            icon={<EditOutlined style={{ color: 'blue' }}/>}/>
                                </Tooltip>
                                <Divider type="vertical"/>
                                <Tooltip title="Borrar herramienta">
                                    <Popconfirm disabled={loading} title="Se borrará la herramienta, ¿Continuar?"
                                                onConfirm={() => didTapRemoveInventory(record)}>
                                        <Button loading={loading} icon={<DeleteOutlined style={{ color: 'red' }}/>}/>
                                    </Popconfirm>
                                </Tooltip>
                            </div>
                        )
                    }}/>
        </Table>
    )
}

InventoryToolsTable.propTypes = {
    data: PropTypes.array
}

export default InventoryToolsTable
